// Thanks to: https://github.com/ant-design/ant-design/blob/master/components/_util/hooks/usePatchElement.ts
import React from 'react';
export function usePatchElement() {
    const [elements, setElements] = React.useState([]);
    const patchElement = React.useCallback((element) => {
        // append a new element to elements (and create a new ref)
        setElements((originElements) => [...originElements, element]);
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return () => {
            setElements((originElements) => originElements.filter((ele) => ele !== element));
        };
    }, []);
    const clearElements = React.useCallback(() => {
        setElements([]);
    }, []);
    return [elements, patchElement, clearElements];
}
